export class ApiModuleOptions {
  serverURL: string
}